export default __webpack_public_path__ + "static/media/logo.f0021de3.png";